<script>

import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomTextDropdown from "../../CustomInput/CustomDropdown.vue";
import CustomCheckbox from "../../global/CustomCheckBox/CheckBox.vue";
import CustomCheckboxGroup from "../../global/CustomCheckBox/CheckBoxGroup.vue";
import {mapState} from "vuex";

export default {
  name: "PoliticInfo",
  components: {CustomCheckboxGroup, CustomCheckbox, CustomTextDropdown, CustomTextField, CommonSubtitle},
  props: {
    politicInfo: {
      type: Object,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPep: false,
      isNotPep: true,
      firstname: '',
      lastname: '',
      position: '',
      relative: ''
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },
  mounted() {
    if (this.user) {
      this.isPep = this.user.is_pep
      this.politicInfo.pep_notes = this.user.pep_notes
    }
  },
  watch: {
    isPep() {
      if (this.isPep) {
        this.isNotPep = false
        this.politicInfo.is_pep = true
      }
    },
    isNotPep() {
      if (this.isNotPep) {
        this.isPep = false
        this.politicInfo.is_pep = false
      }
    }
  }
}
</script>

<template>
  <div>
    <CommonSubtitle :name="$t('kyc.monpep')" alert/>
    <div class="ml-4">
      <h5 class="kyc-sub-title">{{ $t('kyc.monpep_question') }}</h5>
      <div class="row">
        <CustomCheckbox v-model="isPep" label="Тийм" class="ml-3 mb-4"/>
        <CustomCheckbox v-model="isNotPep" label="Үгүй" class="ml-3 mb-4"/>
      </div>
      <div class="row" v-if="isPep">
        <template v-if="politicInfo.pep_notes">
          <div class="col-sm-24 col-md-12 col-lg-8 col-xl-8">
            <CustomTextField :label="$t('kyc.monpep_relative')" v-model="politicInfo.pep_notes"
                             disabled/>
          </div>
        </template>
        <template v-else>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField :label="$t('kyc.lastname')"
                             v-model="politicInfo.pep_lastname"
                             :error="v$.pep_lastname.$error"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField :label="$t('kyc.firstname')"
                             v-model="politicInfo.pep_firstname"
                             :error="v$.pep_firstname.$error"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField :label="$t('kyc.pep_position')"
                             v-model="politicInfo.pep_position"
                             :error="v$.pep_position.$error"
            />
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <CustomTextField :label="$t('kyc.pep_relative')"
                             v-model="politicInfo.pep_relative"
                             :error="v$.pep_relative.$error"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.kyc-sub-title {
  font-size: 14px;
  font-weight: 500;
  color: var(primary-color-new);
}
</style>